import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultUserInfo } from '../interfaces/User'
import { useAuth } from './useAuth'

interface C108SalesCompanyUpdateProps {
  execSalesCompanyUpdate: (loginId: string, salesCompany: string) => Promise<ResultUserInfo>
  loading: loadStatus
}
// C102 ユーザー更新API呼出
export const useC108SalesCompanyUpdate = (): C108SalesCompanyUpdateProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const execSalesCompanyUpdate = async (loginId: string, salesCompany: string) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        //return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // ボディ作成
      const body = { sales_company: salesCompany }
      const response = await axios.post(
        `${baseUrl}${stage}${apiUrl.usersPath}${loginId}/sales-company`,
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      console.log(error)
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }
  return { execSalesCompanyUpdate, loading }
}
